<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>Remembering Farley</title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<p class="textn"> </p>
<p class="textn"> </p>
<p class="textn">Without picking up the phone, Mom can sit in her
  living room and somehow tell what I had for breakfast
  3,000 miles away.</p>
<p class="textn">She can detect a bad-hair day from my handwriting
on a birthday card and feel a shopping blunder in the
middle of the night.</p>
<p class="textn">She can sense my stress level by staring at the moon.
She feels my carbohydrate intake in the air. She can
predict exactly how unbalanced my next bank statement
will be by looking west and squinting.</p>
<p class="textn">She knows if I’m happy, “really” happy, “sort of”
happy, “trying to act happy” happy, or “completely
miserable” happy.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mom016.vue?b6b568dc